import { BaseColor } from '@prophecy/theme';
import { Badges } from '@prophecy/ui-v3/Badges';
import { BadgeProps } from '@prophecy/ui-v3/Badges/types';
import { Dot } from '@prophecy/ui-v3/Indicator';
import { DotSize } from '@prophecy/ui-v3/Indicator/types';

type StatusBadgeProps = {
  tooltip?: BadgeProps['tooltip'];
};

function StatusBadge({
  label,
  tone,
  withDot,
  tooltip
}: StatusBadgeProps & {
  label: string;
  tone: `${BaseColor}`;
  withDot?: boolean;
}) {
  return (
    <Badges
      variant='pillLight'
      tone={tone}
      iconPlacement='left'
      tooltip={tooltip}
      icon={
        withDot ? (
          <Dot tone={tone} size={DotSize.s} data-test-id={`status-badge-${label.toLowerCase()}-dot`} />
        ) : undefined
      }>
      {label}
    </Badges>
  );
}

function statusBadge(label: string, tone: `${BaseColor}`, withDot = false) {
  function Badge(props: StatusBadgeProps) {
    return <StatusBadge label={label} tone={tone} withDot={withDot} {...props} />;
  }

  Badge.displayName = `${label}StatusBadge`;
  return Badge;
}

export const statusBadges = {
  Running: statusBadge('Running', BaseColor.primary, true),
  Cancelling: statusBadge('Cancelling', BaseColor.warning, true),
  Success: statusBadge('Success', BaseColor.success),
  Failed: statusBadge('Failed', BaseColor.error),
  Warning: statusBadge('Warning', BaseColor.warning),
  Cancelled: statusBadge('Cancelled', BaseColor.gray),
  Queued: statusBadge('Queued', BaseColor.gray),
  Skipped: statusBadge('Skipped', BaseColor.gray)
};
